import React from "react";
import { FiCheck, FiChevronRight, FiFileText, FiHome, FiX } from "react-icons/fi";
import { FaUser } from "react-icons/fa";

const SAMPLE_TRANSACTIONS = [
  { id: "ID235435", status: "success", amount: "₹23,800", when: "8 July, 2025 | 10:34 AM" },
  { id: "ID235434", status: "success", amount: "₹23,800", when: "8 July, 2025 | 10:34 AM" },
  { id: "ID235433", status: "failed", amount: "₹23,800", when: "7 July, 2025 | 10:34 AM" },
  { id: "ID235432", status: "success", amount: "₹18,500", when: "6 July, 2025 | 09:12 AM" },
  { id: "ID235431", status: "success", amount: "₹12,000", when: "5 July, 2025 | 04:22 PM" },
  { id: "ID235430", status: "success", amount: "₹23,800", when: "4 July, 2025 | 11:05 AM" },
  { id: "ID235429", status: "success", amount: "₹9,750", when: "3 July, 2025 | 08:41 AM" },
];

const SAMPLE_LOANS = [
  {
    id: "2025989843545",
    amount: "₹25,000",
    status: "active",
    period: "8/09/2025 - 20/09/2025",
  },
  {
    id: "2025989843546",
    amount: "₹25,000",
    status: "paid",
    period: "8/09/2025 - 20/09/2025",
  },
  {
    id: "2025989843547",
    amount: "₹18,000",
    status: "paid",
    period: "1/08/2025 - 15/08/2025",
  },
];

const EmptyStateArt = () => (
  <svg viewBox="0 0 120 108" width="88" height="80" fill="none" aria-hidden="true">
    <path
      d="M60 14 108 96H12L60 14Z"
      stroke="#1a1a22"
      strokeWidth="3.2"
      strokeLinejoin="round"
    />
    <path d="M88 62 108 96" stroke="#1a1a22" strokeWidth="3.2" strokeLinecap="round" />
    <path d="M96 74l8 14M92 82l10 12M90 90l8 10" stroke="#1a1a22" strokeWidth="1.6" />
    <rect x="56.5" y="42" width="7" height="28" rx="1.5" fill="#1a1a22" />
    <circle cx="60" cy="80" r="4.2" fill="#1a1a22" />
  </svg>
);

const FwPaymentHistoryScreen = ({
  activeTab = "transactions",
  onTabChange,
  onNavChange,
}) => {
  const isLoans = activeTab === "loans";

  return (
    <section className="fw-screen fw-screen--profile fw-screen--payments fw-fade">
      <div className="fw-payments">
        <h1 className="fw-payments__title">Payment History</h1>

        <div className="fw-payments__tabs" role="tablist">
          <button
            type="button"
            role="tab"
            aria-selected={!isLoans}
            className={`fw-payments__tab ${!isLoans ? "is-active" : ""}`}
            onClick={() => onTabChange?.("transactions")}
          >
            Transactions
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={isLoans}
            className={`fw-payments__tab ${isLoans ? "is-active" : ""}`}
            onClick={() => onTabChange?.("loans")}
          >
            Loans
          </button>
        </div>

        <div className="fw-payments__body">
          {!isLoans ? (
            SAMPLE_TRANSACTIONS.length ? (
              <ul className="fw-payments__list">
                {SAMPLE_TRANSACTIONS.map((item) => {
                  const ok = item.status === "success";
                  return (
                    <li key={item.id} className="fw-payments__row">
                      <span
                        className={`fw-payments__status-icon ${ok ? "is-ok" : "is-fail"}`}
                        aria-hidden="true"
                      >
                        {ok ? <FiCheck strokeWidth={3} /> : <FiX strokeWidth={3} />}
                      </span>
                      <div className="fw-payments__meta">
                        <strong>{ok ? "Payment Successful" : "Payment Failed"}</strong>
                        <span>Transaction ID</span>
                        <em>{item.id}</em>
                      </div>
                      <div className="fw-payments__right">
                        <strong>{item.amount}</strong>
                        <span>{item.when}</span>
                      </div>
                    </li>
                  );
                })}
              </ul>
            ) : (
              <div className="fw-payments__empty">
                <EmptyStateArt />
                <p>
                  There are currently no transactions available to display. Please check back later
                  or perform a transaction to view it here.
                </p>
              </div>
            )
          ) : SAMPLE_LOANS.length ? (
            <ul className="fw-payments__list fw-payments__list--loans">
              {SAMPLE_LOANS.map((loan) => {
                const paid = loan.status === "paid";
                return (
                  <li key={loan.id} className="fw-loan-row">
                    <div className="fw-loan-row__top">
                      <strong>{loan.amount}</strong>
                      <span className={`fw-loan-badge ${paid ? "is-paid" : "is-active"}`}>
                        {paid ? (
                          <>
                            <i aria-hidden="true">
                              <FiCheck strokeWidth={3} />
                            </i>
                            Paid
                          </>
                        ) : (
                          "Active"
                        )}
                      </span>
                    </div>
                    <div className="fw-loan-row__bottom">
                      <span>Loan ID: {loan.id}</span>
                      <span className="fw-loan-row__period">
                        {loan.period}
                        {paid && <FiChevronRight aria-hidden="true" />}
                      </span>
                    </div>
                  </li>
                );
              })}
            </ul>
          ) : (
            <div className="fw-payments__empty">
              <EmptyStateArt />
              <p>
                There are currently no loan records available. Please check back later or apply for a
                loan to view it here.
              </p>
            </div>
          )}
        </div>
      </div>

      <nav className="fw-profile-tabbar" aria-label="Main">
        <button
          type="button"
          className="fw-profile-tabbar__item"
          onClick={() => onNavChange?.("home")}
        >
          <FiHome strokeWidth={1.7} />
          <span className="fw-sr-only">Home</span>
        </button>
        <button
          type="button"
          className="fw-profile-tabbar__item fw-profile-tabbar__item--profile is-active"
        >
          <FiFileText strokeWidth={1.7} />
          <span>Payment</span>
        </button>
        <button
          type="button"
          className="fw-profile-tabbar__item"
          onClick={() => onNavChange?.("profile")}
        >
          <FaUser />
          <span className="fw-sr-only">Profile</span>
        </button>
      </nav>
      <div className="fw-profile-home-bar" aria-hidden="true" />
    </section>
  );
};

export default FwPaymentHistoryScreen;
